// Карта видимости разделов для сайдбара и стража маршрутов (api/nav.ts).
// Пока карта грузится, отдаём null — потребители берут поведение из кода,
// поэтому меню рисуется сразу и не мигает.
import { useEffect, useState } from 'react'
import { cachedNavBadges, cachedNavLayout, cachedNavModes, fetchNavModes, type NavBadges, type NavLayout, type NavModes } from '../api/nav'

export function useNavModes(): { modes: NavModes | null; badges: NavBadges | null; layout: NavLayout | null; loaded: boolean } {
	const [modes, setModes] = useState<NavModes | null>(() => cachedNavModes())
	// Ярлыки «new» приходят тем же запросом; читаем кэш после загрузки карты режимов.
	const [badges, setBadges] = useState<NavBadges | null>(() => cachedNavBadges())
	const [layout, setLayout] = useState<NavLayout | null>(() => cachedNavLayout())

	useEffect(() => {
		if (modes) return
		let alive = true
		void fetchNavModes().then((m) => {
			if (alive) {
				setModes(m)
				setBadges(cachedNavBadges())
				setLayout(cachedNavLayout())
			}
		})
		return () => {
			alive = false
		}
	}, [modes])

	return { modes, badges, layout, loaded: modes !== null }
}
